import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_redo.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconRedo = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconRedo;
